import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { Routes, Route } from "react-router-dom";

import loadable from "@loadable/component";

// Main components
import Ubication from "./components/pages/Ubication";
import NoMatch from "./components/pages/NoMatch";

// i18n
import { initi18n } from "./i18n/main_i18n";
import ResumeWrapper from "./components/pages/ResumeWrapper";
import Layout from "./components/layout/Layout";

const Confirmation = loadable(
  () => import(/* webpackPrefetch: true */ "./components/pages/Confirmation")
);
const Schedule = loadable(
  () => import(/* webpackPrefetch: true */ "./components/pages/ScheduleV2")
);
const ClientData = loadable(
  () => import(/* webpackPrefetch: true */ "./components/pages/ClientData")
);
const Resume = loadable(
  () => import(/* webpackPrefetch: true */ "./components/pages/Resume")
);
const MapView = loadable(
  () => import(/* webpackPrefetch: true */ "./components/pages/MapView")
);
const LandingPage = loadable(
  () => import(/* webpackPrefetch: true */ "./components/pages/LandingPage")
);

// CodeOptic flow components
const CodeOpticLanding = loadable(
  () => import(/* webpackPrefetch: true */ "./components/pages/codeOptic/CodeOpticLanding")
);
const CodeOpticSchedule = loadable(
  () => import(/* webpackPrefetch: true */ "./components/pages/codeOptic/CodeOpticSchedule")
);
const CodeOpticUuidSchedule = loadable(
  () => import(/* webpackPrefetch: true */ "./components/pages/codeOptic/CodeOpticUuidSchedule")
);
const PostCodeUbicationPage = loadable(
  () => import(/* webpackPrefetch: true */ "./components/pages/postCodeUbication/PostCodeUbicationPage")
);
const CodeOpticClientData = loadable(
  () => import(/* webpackPrefetch: true */ "./components/pages/codeOptic/CodeOpticClientData")
);

// init i18n
initi18n();

function App() {
  return (
    <Layout>
    <Routes>
      {/* Normal flow routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="landing" element={<LandingPage />} />
      <Route path="ubicacion/:idLead?" element={<Ubication />} />
      <Route path="horarios" element={<Schedule />} />
      <Route path="form" element={<ClientData />} />
      <Route path="confirmacion" element={<Confirmation />} />
      <Route path="resume" element={<ResumeWrapper />} />
      <Route path="resume/:idAppointment?" element={<Resume />} />
      <Route path="map" element={<MapView />} />
      
      {/* CodeOptic flow routes - Direct optic appointment */}
      <Route path="cita-optica" element={<CodeOpticLanding />} />
      <Route path="cita-optica/horarios" element={<CodeOpticSchedule />} />
      <Route path="cita-optica/uuid/:opticUuid/:customerUuid" element={<CodeOpticUuidSchedule />} />
      <Route path="cita-optica/postal/:postCode/:customerUuid" element={<PostCodeUbicationPage />} />
      <Route path="cita-optica/postal/:postCode/:customerUuid/:countryCode" element={<PostCodeUbicationPage />} />
      <Route path="cita-optica/datos" element={<CodeOpticClientData />} />
      
      <Route path="*" element={<NoMatch />} />
    </Routes>
    </Layout>
  );
}

export default App;
